import { LicenseInfo } from '@mui/x-license';
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY as string);

// Datadog must not initialize in Salesforce widget bundles — LWS blocks
// RUM's window.onunhandledrejection patch and aborts before window.wa is set.
// See vite.config.widgets.ts aliases to src/integrations/stubs/.

import '@/i18n';
import investorWidgetMap from '@/widget-mappings/InvestorWidgetMap';
import { createWidgetNamespace } from './createWidgetNamespace';

createWidgetNamespace('investor', investorWidgetMap);
